import { Form, message } from 'antd'
import {
  reducer,
  initialState,
  setDetailInfoAction,
  setIsLoadingAction,
  setHideClientInfoAction,
  setImportModalOpenAction,
  setImportUploadListAction,
  setImportOriginFileAction,
  setImportConfirmLoadingAction,
  setQuotationItemCountAction,
  setQuotationItemsPageAction,
  setQuotationPageOptionAction,
  setEditModalOpenAction,
  setEditTabIndexAction,
} from '@/pages/inquiryDetail/reducer'
import { useEffect, useMemo, useReducer, useRef } from 'react'
import {
  GET_INQUIRY_DETAIL,
  SUBMIT_QUOTATION,
  SubmitQuotationDTO,
  CONFIRM_ACCEPT,
  IMPORT_INQUIRY_DETAIL_PAGE,
  EXPORT_INQUIRY_DETAIL_PAGE,
  GET_QUOTATION_ITEM_COUNT,
  PAGE_QUERY_QUOTATION_ITEMS,
  SUBMIT_BATCH_QUOTATION_ITEMS,
  SubmitBatchQuotationItemsDTO,
  TEMP_SAVE_QUOTATION,
  GIVE_UP_QUOTATION_ITEM,
} from '@/api/inquiry'
import { isResponseSuccess } from '@/tools'

import { useLocation } from 'react-router-dom'
import { useQuery } from '@/tools/utilHooks'
import { BJDFormRef } from './components/BJDForm'
import { CustomerConfirm } from '@/components/ModalUser'
import {
  convertAttatchmentList,
  parseAttachmentList,
} from './components/AttachmentPreview/utils'
import { current } from 'immer'
import moment from 'moment'
import { RcFile } from 'antd/lib/upload'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { getInquiryListRowKey } from '.'
import { supplierInquiryItemStatusEnum } from '@/global/enum'
import RadioTabs from '@/components/RadioTabs'
import { setCurrentTabKeyAction } from './reducer'
interface RouteParams {
  scrollToSupplierBJList?: boolean
}
export function useSetupHook() {
  const [form] = Form.useForm()
  const [editForm] = Form.useForm()
  //   const { value } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const { detailInfo, hideClientInfo, quotationItemsPage } = state
  const { state: routeState } = useLocation<RouteParams>()
  const bjdFormRef = useRef<BJDFormRef>(null)
  const initTabKeyRef = useRef(false)
  const query = useQuery()
  const id = query.get('id') || ''

  useEffect(() => {
    refreshPage()
    return () => {}
  }, [id])
  useEffect(() => {
    if (routeState) {
      if (routeState?.scrollToSupplierBJList) {
        document.getElementById('supplierBJList')?.scrollIntoView({
          behavior: 'smooth',
        })
      }
    }

    return () => {}
  }, [routeState])

  async function getDetailInfo() {
    dispatch(setIsLoadingAction(true))
    const res = await GET_INQUIRY_DETAIL(id)
    if (isResponseSuccess(res)) {
      dispatch(setDetailInfoAction(res.data))

      // 设置表单值，映射detailInfo到表单字段
      const detailInfo = res.data
      const formValues = {
        // 供应商信息字段
        supplierName: detailInfo.supplierName,
        contactPerson: detailInfo.contactPerson,
        contactPhone: detailInfo.contactPhone,
        contactEmail: detailInfo.contactEmail,
        supplierAddress: detailInfo.supplierAddress,
        validUntil: detailInfo.validUntil
          ? moment(detailInfo.validUntil)
          : undefined,
        // 附件列表 - 将字符串转换为文件列表格式
        attachmentList: parseAttachmentList(detailInfo.quotationAttachment),
        attachment: detailInfo.quotationAttachment,
        // 询价清单明细 - 映射到quotationOrderItemParamList数组
        quotationOrderItemParamList: [],
        // quotationOrderItemParamList:
        //   detailInfo.items?.map((item: any) => ({
        //     unitPrice: item.unitPrice,
        //     quoteProductCode: item.quoteProductCode,
        //     quoteProductBrand: item.quoteProductBrand,
        //     quoteProductName: item.quoteProductName,
        //     quoteProductSpec: item.quoteProductSpec,
        //     quoteUnit: item.quoteUnit,
        //     quoteUnitCode: item.quoteUnitCode,
        //     deliveryPeriod: item.deliveryPeriod,
        //     includeFreight: item.includeFreight,
        //     configDetail: item.configDetail,
        //     remark: item.remark,
        //     // 附件列表 - 每个明细项的附件
        //     attachmentList: parseAttachmentList(item.attachment),
        //     attachment: item.attachment,
        //   })) || [],
      }

      form.setFieldsValue(formValues)
    } else {
      message.error(res.msg)
    }
    dispatch(setIsLoadingAction(false))
  }
  function buildOrderParamsFromDetail(detailItems: any[] = []) {
    return detailItems.map((src: any) => {
      return {
        unitPrice: src.unitPrice,
        quoteProductCode: src.quoteProductCode,
        quoteProductBrand: src.quoteProductBrand,
        quoteProductName: src.quoteProductName,
        quoteProductSpec: src.quoteProductSpec,
        quoteUnit: src.quoteUnit,
        quoteUnitCode: src.quoteUnitCode,
        deliveryPeriod: src.deliveryPeriod,
        includeFreight: src.includeFreight,
        configDetail: src.configDetail,
        paramDifference: src.paramDifference,
        marketPrice: src.marketPrice,
        remark: src.remark,
        attachmentList: parseAttachmentList(src.attachment),
        attachment: src.attachment,
      }
    })
  }
  function hasDetailContent(v: any) {
    if (!v) return false
    const fields = [
      v.unitPrice,
      v.quoteProductCode,
      v.quoteProductBrand,
      v.quoteProductName,
      v.quoteProductSpec,
      v.quoteUnitCode,
      v.quoteUnit,
      v.deliveryPeriod,
      v.marketPrice,
      v.configDetail,
      v.paramDifference,
      v.remark,
    ]
    const hasAttachment =
      Array.isArray(v.attachmentList) && v.attachmentList.length > 0
    return (
      fields.some((x) => x !== undefined && x !== null && x !== '') ||
      hasAttachment
    )
  }
  function buildValidateNames(list: any[], requiredFields: string[]) {
    const names: any[] = []
    list.forEach((v: any, idx: number) => {
      if (hasDetailContent(v)) {
        requiredFields.forEach((field) => {
          names.push(['quotationOrderItemParamList', idx, field])
        })
      }
    })
    return names
  }
  const currentTableMemo = useMemo(() => {
    const allList = quotationItemsPage || []
    const isUnquoted = (r: any) =>
      supplierInquiryItemStatusEnum.isValueInLabels(r?.itemStatus, ['待报价'])
    const isTerminal = (r: any) =>
      supplierInquiryItemStatusEnum.isValueInLabels(r?.itemStatus, [
        '已放弃',
        '无需报价',
      ])
    const quotedList = allList.filter((r) => !isUnquoted(r) && !isTerminal(r))
    const unquotedList = allList.filter((r) => isUnquoted(r))

    const radioItemDict = {
      all: { value: `全部(${allList.length})` },
      quoted: { value: `已报价(${quotedList.length})` },
      unquoted: { value: `待报价(${unquotedList.length})` },
    }

    const key = state.currentTabKey || 'all'
    const dataSource =
      key === 'quoted'
        ? quotedList
        : key === 'unquoted'
          ? unquotedList
          : allList
    // 过滤掉已放弃和无需报价的数据，供弹框(XJForm)和提交使用
    const editDataSource = dataSource.filter((r) => !isTerminal(r))

    return {
      dataSource,
      editDataSource,
      expandedRowKeys: dataSource.map(getInquiryListRowKey),
      radioItemDict,
      defaultKey: key,
    }
  }, [quotationItemsPage, state.currentTabKey])
  async function refreshPage(options?: { skipDetailInfo?: boolean }) {
    const promises = [getItemCount(), getPagedItems()]
    if (!options?.skipDetailInfo) {
      promises.push(getDetailInfo())
    }
    await Promise.all(promises)
  }

  const toggleHideClientInfo = () => {
    dispatch(setHideClientInfoAction(!hideClientInfo))
  }

  async function getItemCount() {
    if (!id) return
    const res = await GET_QUOTATION_ITEM_COUNT(id)
    if (isResponseSuccess(res)) {
      dispatch(setQuotationItemCountAction(res.data))
      if (!initTabKeyRef.current) {
        const unquoted = res.data?.unquotedItemCount ?? 0
        dispatch(setCurrentTabKeyAction(unquoted > 0 ? 'unquoted' : 'all'))
        initTabKeyRef.current = true
      }
    } else {
      message.error(res.msg)
    }
  }

  async function getPagedItems() {
    if (!id) return
    const pageNo = state.quotationPageOption?.pageNo ?? 1
    const pageSize = state.quotationPageOption?.pageSize ?? 100000
    const res = await PAGE_QUERY_QUOTATION_ITEMS(id, { pageNo, pageSize })
    if (isResponseSuccess(res)) {
      dispatch(setQuotationItemsPageAction(res.data.content))
      dispatch(
        setQuotationPageOptionAction({
          pageNo: res.data.pageNo,
          pageSize: res.data.pageSize,
          totalCount: res.data.totalCount,
        }),
      )
      // const quotationOrderItemParamList = buildOrderParamsFromDetail(
      //   state.detailInfo?.items || [],
      // )
      // form.setFieldsValue({ quotationOrderItemParamList })
    } else {
      message.error(res.msg)
    }
  }

  function setCurrentTabKey(key: 'all' | 'quoted' | 'unquoted') {
    dispatch(setCurrentTabKeyAction(key))
  }

  function setQuotationPageOption(pageNo: number, pageSize?: number) {
    dispatch(
      setQuotationPageOptionAction({
        pageNo,
        pageSize: pageSize ?? state.quotationPageOption?.pageSize ?? 20,
        totalCount: state.quotationPageOption?.totalCount ?? 0,
      }),
    )
    getPagedItems()
  }

  function openEditModalForRecord(record: any) {
    const detailItems = currentTableMemo.dataSource || []
    const targetKey = getInquiryListRowKey(record)
    const idx = detailItems.findIndex(
      (it: any) => getInquiryListRowKey(it) === targetKey,
    )
    if (idx === -1) {
      message.warning('未找到对应明细，无法编辑')
      return
    }
    const quotationOrderItemParamList = buildOrderParamsFromDetail(detailItems)
    editForm.setFieldsValue({ quotationOrderItemParamList })
    dispatch(setEditTabIndexAction(idx))
    dispatch(setEditModalOpenAction(true))
  }

  function closeEditModal() {
    dispatch(setEditModalOpenAction(false))
  }

  function handleConfirmOrder() {
    CustomerConfirm({
      title: '确认接单？',
      content:
        '如果您核对好了询价单的信息，确认后续会给咸亨报价，请提前确认接单以便锁单',
      onOk: async () => {
        try {
          if (!id) {
            message.warning('询价ID不能为空')
            return
          }
          const hideLoading = message.loading('锁单中')
          dispatch(setIsLoadingAction(true))
          const res = await CONFIRM_ACCEPT({ inquiryId: id })

          if (isResponseSuccess(res)) {
            hideLoading()
            message.success('已成功锁单！请尽快报价')
            // 刷新页面数据
            await refreshPage()
          } else {
            console.error(res.msg || '接单失败，请重试')
          }
        } catch (error: any) {
          console.error('确认接单失败:', error)
        } finally {
          dispatch(setIsLoadingAction(false))
        }
      },
    })
  }

  function handleSubmitQuotation() {
    CustomerConfirm({
      title: '确认提交报价？',
      content: '是否确认提交？提交后信息不能主动修改，请仔细核对后再提交',
      onOk: async () => {
        try {
          // 验证表单
          const formValues = await form.validateFields()

          // 构建提交报价的参数
          const submitParams: SubmitQuotationDTO = {
            inquiryId: id,
            supplierId: detailInfo?.supplierId || '',
            contactPerson: formValues.contactPerson,
            contactPhone: formValues.contactPhone,
            contactEmail: formValues.contactEmail,
            supplierAddress: formValues.supplierAddress,
            validUntil: formValues.validUntil
              ? moment(formValues.validUntil).endOf('day').valueOf()
              : undefined,

            attachment: convertAttatchmentList(formValues.attachmentList),
            // 处理报价明细
            // items:
            //   formValues.quotationOrderItemParamList?.map(
            //     (item: any, index: number) => {
            //       const originalItem = detailInfo?.items?.[index]
            //       return {
            //         inquiryItemId:
            //           originalItem?.inquiryItemId || originalItem?.id || '',
            //         quoteProductName: item.quoteProductName,
            //         quoteProductCode: item.quoteProductCode,
            //         quoteProductSpec: item.quoteProductSpec,
            //         quoteProductBrand: item.quoteProductBrand,
            //         quoteQty: originalItem?.clientMaterialQty || 1,
            //         quoteUnit: item.quoteUnit,
            //         quoteUnitCode: item.quoteUnitCode,
            //         unitPrice: item.unitPrice,
            //         amount:
            //           (item.unitPrice || 0) *
            //           (originalItem?.clientMaterialQty || 1),
            //         deliveryPeriod: item.deliveryPeriod,
            //         includeFreight: item.includeFreight,
            //         configDetail: item.configDetail,
            //         remark: item.remark,
            //         attachment: convertAttatchmentList(
            //           item.attachmentList || [],
            //         ),
            //       }
            //     },
            //   ) || [],

            quotationId: detailInfo?.quotationId, // 编辑时使用
          }

          dispatch(setIsLoadingAction(true))
          const res = await SUBMIT_QUOTATION(submitParams)

          if (isResponseSuccess(res)) {
            message.success('报价提交成功！')
            // 刷新页面数据
            await refreshPage()
          } else {
            console.error(res.msg || '提交失败，请重试')
          }
        } catch (error: any) {
          console.error('提交报价失败:', error)
          const errorField = (error as any)?.errorFields?.[0]
          if (errorField) {
            if (errorField?.name?.includes('quotationOrderItemParamList')) {
              const tabIndex = errorField?.name?.[1]

              // 获取物资名称用于提示
              const materialName =
                detailInfo?.items?.[tabIndex]?.clientMaterialName ||
                `明细${tabIndex + 1}`
              // 显示轻提示
              message.warning(`「${materialName}」必填项未全部填写`)
              // 切换到对应的页签
              bjdFormRef.current!.getXJFormRef()?.current?.switchToTab(tabIndex)
            } else {
              // 其他表单验证错误
              message.warning(errorField?.errors?.[0] || '表单验证失败')
              // form.scrollToField(errorField?.name)
            }
          } else {
            // 未知错误
            message.warning('提交失败，请检查表单信息')
          }
        } finally {
          dispatch(setIsLoadingAction(false))
        }
      },
    })
  }

  async function handleTempSave() {
    try {
      const values = form.getFieldsValue()
      const list = values?.quotationOrderItemParamList || []
      const dataSource = currentTableMemo.dataSource || []
      const submitParams = {
        inquiryId: id,
        supplierId: state.detailInfo?.supplierId || '',
        quotationId: state.detailInfo?.quotationId,
        contactPerson: values.contactPerson,
        contactPhone: values.contactPhone,
        contactEmail: values.contactEmail,
        supplierAddress: values.supplierAddress,
        validUntil: values.validUntil
          ? moment(values.validUntil).endOf('day').valueOf()
          : undefined,
        attachment: convertAttatchmentList(values.attachmentList || []),
      }

      const hideMsg = message.loading('暂存中')
      dispatch(setIsLoadingAction(true))
      const res = await TEMP_SAVE_QUOTATION(submitParams)
      hideMsg()
      if (isResponseSuccess(res)) {
        message.success('操作成功')
        await refreshPage()
      } else {
        console.error(res?.msg)
      }
    } catch (e: any) {
      // message.error(e?.message || '暂存失败，请重试')
      console.error(e)
    } finally {
      dispatch(setIsLoadingAction(false))
    }
  }

  async function submitDetailList() {
    try {
      const values = editForm.getFieldsValue()
      const list = values?.quotationOrderItemParamList || []
      const dataSource = currentTableMemo.editDataSource || []

      const requiredFields = [
        'unitPrice',
        'quoteProductBrand',
        'quoteProductName',
        'quoteUnitCode',
        'quoteUnit',
        'deliveryPeriod',
        'includeFreight',
      ]
      const toValidateNames = buildValidateNames(list, requiredFields)

      try {
        if (toValidateNames.length > 0) {
          await editForm.validateFields(toValidateNames)
        }
      } catch (error: any) {
        const errorFields = (error?.errorFields || []) as any[]
        const invalidIdxSet = new Set<number>()
        errorFields.forEach((ef) => {
          const n = ef?.name?.[1]
          if (typeof n === 'number') invalidIdxSet.add(n)
        })
        const n = invalidIdxSet.size
        if (n > 0) {
          message.warning(`有${n}条明细的报价信息没有填写完整，请确认！`)
          const firstIdx = Math.min(...Array.from(invalidIdxSet))
          bjdFormRef.current?.getXJFormRef()?.current?.switchToTab(firstIdx)
          const firstErrorName = errorFields.find(
            (ef) => ef?.name?.[1] === firstIdx,
          )?.name
          if (firstErrorName) {
            editForm.scrollToField(firstErrorName)
          }
          return
        }
      }

      const items = list
        .map((v: any, idx: number) => {
          if (!hasDetailContent(v)) return undefined
          const origin = dataSource[idx]
          const qty = origin?.clientMaterialQty || 1
          return {
            inquiryItemId: origin?.inquiryItemId || origin?.id || '',
            unitPrice: v.unitPrice,
            marketPrice: v.marketPrice,
            quoteProductCode: v.quoteProductCode,
            quoteProductBrand: v.quoteProductBrand,
            quoteProductName: v.quoteProductName,
            quoteProductSpec: v.quoteProductSpec,
            quoteQty: qty,
            quoteUnit: v.quoteUnit,
            quoteUnitCode: v.quoteUnitCode,
            deliveryPeriod: v.deliveryPeriod,
            includeFreight: v.includeFreight,
            configDetail: v.configDetail,
            paramDifference: v.paramDifference,
            remark: v.remark,
            attachment: convertAttatchmentList(v.attachmentList || []),
            amount: (v.unitPrice || 0) * qty,
          }
        })
        .filter(Boolean)

      const submitParams: SubmitBatchQuotationItemsDTO = {
        inquiryId: id,
        supplierId: state.detailInfo?.supplierId || '',
        items: items as any,
      }

      const hideMsg = message.loading('保存中')
      dispatch(setIsLoadingAction(true))
      const res = await SUBMIT_BATCH_QUOTATION_ITEMS(submitParams)
      hideMsg()
      if (isResponseSuccess(res)) {
        message.success('操作成功')
        dispatch(setEditModalOpenAction(false))
        const autoResult = (res.data as any)?.autoSubmitResult
        if (autoResult?.autoSubmitted) {
          // 自动提交成功，整单状态已变化
          message.success(autoResult.message || '整单已自动提交')
          await refreshPage()
        } else if (autoResult?.errorMessage) {
          // 明细报价成功，但自动提交整单失败
          message.warning(autoResult.errorMessage)
          await refreshPage({ skipDetailInfo: true })
        } else {
          // 仍有未完成明细，正常刷新
          await refreshPage({ skipDetailInfo: true })
        }
      } else {
        console.error(res?.msg)
      }
    } catch (e: any) {
      console.error(e?.message || '暂存失败，请重试')
    } finally {
      dispatch(setIsLoadingAction(false))
    }
  }

  const onImportOpenChange = (open: boolean) =>
    dispatch(setImportModalOpenAction(open))

  const onImportFileChange = (list: fileFile[]) => {
    dispatch(setImportUploadListAction(list))
  }

  const getImportOriginFile = (file: RcFile) =>
    dispatch(setImportOriginFileAction(file))

  const onConfirmImport = async () => {
    if (state.importUploadList.length < 1) {
      message.warning('请上传导入文件')
      return
    }
    dispatch(setImportConfirmLoadingAction(true))
    const hideMsg = message.loading('导入中')
    try {
      const res = await IMPORT_INQUIRY_DETAIL_PAGE(state.importOriginFile!, {
        inquiryId: id,
      })
      if (isResponseSuccess(res)) {
        dispatch(setImportModalOpenAction(false))
        dispatch(setImportUploadListAction([]))
        dispatch(setImportOriginFileAction(undefined))
      }
    } catch (e: any) {
      console.error(e?.message || '导入失败')
    } finally {
      // 固定关闭弹窗
      dispatch(setImportModalOpenAction(false))
      // 无论成功失败都刷新
      await refreshPage()
      hideMsg()
      dispatch(setImportConfirmLoadingAction(false))
    }
  }

  const handleExport = async () => {
    if (!id) {
      message.warning('询价ID不能为空')
      return
    }
    const hideMsg = message.loading('导出中')
    try {
      await EXPORT_INQUIRY_DETAIL_PAGE({ inquiryId: id })
    } finally {
      hideMsg()
    }
  }

  // 放弃
  function handleGiveUpQuotation(record: any) {
    CustomerConfirm({
      title: '确认放弃报价？',
      content: '放弃后该明细将不可继续报价，是否确认放弃？',
      onOk: async () => {
        try {
          const hideLoading = message.loading('操作中')
          const res = await GIVE_UP_QUOTATION_ITEM({
            inquiryId: id,
            inquiryItemId: record.inquiryItemId || record.id || '',
            supplierId: state.detailInfo?.supplierId,
          })
          hideLoading()
          if (isResponseSuccess(res)) {
            message.success('放弃报价成功')
            const autoResult = res.data
            if (autoResult?.autoSubmitted) {
              // 自动提交成功，整单状态已变化
              message.success(autoResult.message || '整单已自动提交')
              await refreshPage()
            } else if (autoResult?.errorMessage) {
              // 明细已放弃，但自动提交整单失败
              message.warning(autoResult.errorMessage)
              await refreshPage({ skipDetailInfo: true })
            } else {
              // 仍有未完成明细，正常刷新
              await refreshPage({ skipDetailInfo: true })
            }
          } else {
            message.error(res.msg || '放弃报价失败')
          }
        } catch (error: any) {
          message.error('放弃报价失败，请重试')
          console.error('放弃报价失败:', error)
        }
      },
    })
  }

  return {
    state,
    form,
    editForm,
    refreshPage,
    toggleHideClientInfo,
    bjdFormRef,
    handleConfirmOrder,
    handleSubmitQuotation,
    handleTempSave,
    submitDetailList,
    handleExport,
    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
    currentTableMemo,
    setCurrentTabKey,
    setQuotationPageOption,
    openEditModalForRecord,
    closeEditModal,
    handleGiveUpQuotation,
  }
}
import { Form, message } from 'antd'
import {
  reducer,
  initialState,
  setDetailInfoAction,
  setIsLoadingAction,
  setHideClientInfoAction,
  setImportModalOpenAction,
  setImportUploadListAction,
  setImportOriginFileAction,
  setImportConfirmLoadingAction,
  setQuotationItemCountAction,
  setQuotationItemsPageAction,
  setQuotationPageOptionAction,
  setEditModalOpenAction,
  setEditTabIndexAction,
} from '@/pages/inquiryDetail/reducer'
import { useEffect, useMemo, useReducer, useRef } from 'react'
import {
  GET_INQUIRY_DETAIL,
  SUBMIT_QUOTATION,
  SubmitQuotationDTO,
  CONFIRM_ACCEPT,
  IMPORT_INQUIRY_DETAIL_PAGE,
  EXPORT_INQUIRY_DETAIL_PAGE,
  GET_QUOTATION_ITEM_COUNT,
  PAGE_QUERY_QUOTATION_ITEMS,
  SUBMIT_BATCH_QUOTATION_ITEMS,
  SubmitBatchQuotationItemsDTO,
  TEMP_SAVE_QUOTATION,
  GIVE_UP_QUOTATION_ITEM,
} from '@/api/inquiry'
import { isResponseSuccess } from '@/tools'

import { useLocation } from 'react-router-dom'
import { useQuery } from '@/tools/utilHooks'
import { BJDFormRef } from './components/BJDForm'
import { CustomerConfirm } from '@/components/ModalUser'
import {
  convertAttatchmentList,
  parseAttachmentList,
} from './components/AttachmentPreview/utils'
import { current } from 'immer'
import moment from 'moment'
import { RcFile } from 'antd/lib/upload'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { getInquiryListRowKey } from '.'
import { supplierInquiryItemStatusEnum } from '@/global/enum'
import RadioTabs from '@/components/RadioTabs'
import { setCurrentTabKeyAction } from './reducer'
interface RouteParams {
  scrollToSupplierBJList?: boolean
}
export function useSetupHook() {
  const [form] = Form.useForm()
  const [editForm] = Form.useForm()
  //   const { value } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const { detailInfo, hideClientInfo, quotationItemsPage } = state
  const { state: routeState } = useLocation<RouteParams>()
  const bjdFormRef = useRef<BJDFormRef>(null)
  const initTabKeyRef = useRef(false)
  const query = useQuery()
  const id = query.get('id') || ''

  useEffect(() => {
    refreshPage()
    return () => {}
  }, [id])
  useEffect(() => {
    if (routeState) {
      if (routeState?.scrollToSupplierBJList) {
        document.getElementById('supplierBJList')?.scrollIntoView({
          behavior: 'smooth',
        })
      }
    }

    return () => {}
  }, [routeState])

  async function getDetailInfo() {
    dispatch(setIsLoadingAction(true))
    const res = await GET_INQUIRY_DETAIL(id)
    if (isResponseSuccess(res)) {
      dispatch(setDetailInfoAction(res.data))

      // 设置表单值，映射detailInfo到表单字段
      const detailInfo = res.data
      const formValues = {
        // 供应商信息字段
        supplierName: detailInfo.supplierName,
        contactPerson: detailInfo.contactPerson,
        contactPhone: detailInfo.contactPhone,
        contactEmail: detailInfo.contactEmail,
        supplierAddress: detailInfo.supplierAddress,
        validUntil: detailInfo.validUntil
          ? moment(detailInfo.validUntil)
          : undefined,
        // 附件列表 - 将字符串转换为文件列表格式
        attachmentList: parseAttachmentList(detailInfo.quotationAttachment),
        attachment: detailInfo.quotationAttachment,
        // 询价清单明细 - 映射到quotationOrderItemParamList数组
        quotationOrderItemParamList: [],
        // quotationOrderItemParamList:
        //   detailInfo.items?.map((item: any) => ({
        //     unitPrice: item.unitPrice,
        //     quoteProductCode: item.quoteProductCode,
        //     quoteProductBrand: item.quoteProductBrand,
        //     quoteProductName: item.quoteProductName,
        //     quoteProductSpec: item.quoteProductSpec,
        //     quoteUnit: item.quoteUnit,
        //     quoteUnitCode: item.quoteUnitCode,
        //     deliveryPeriod: item.deliveryPeriod,
        //     includeFreight: item.includeFreight,
        //     configDetail: item.configDetail,
        //     remark: item.remark,
        //     // 附件列表 - 每个明细项的附件
        //     attachmentList: parseAttachmentList(item.attachment),
        //     attachment: item.attachment,
        //   })) || [],
      }

      form.setFieldsValue(formValues)
    } else {
      message.error(res.msg)
    }
    dispatch(setIsLoadingAction(false))
  }
  function buildOrderParamsFromDetail(detailItems: any[] = []) {
    return detailItems.map((src: any) => {
      return {
        unitPrice: src.unitPrice,
        quoteProductCode: src.quoteProductCode,
        quoteProductBrand: src.quoteProductBrand,
        quoteProductName: src.quoteProductName,
        quoteProductSpec: src.quoteProductSpec,
        quoteUnit: src.quoteUnit,
        quoteUnitCode: src.quoteUnitCode,
        deliveryPeriod: src.deliveryPeriod,
        includeFreight: src.includeFreight,
        configDetail: src.configDetail,
        paramDifference: src.paramDifference,
        marketPrice: src.marketPrice,
        remark: src.remark,
        attachmentList: parseAttachmentList(src.attachment),
        attachment: src.attachment,
      }
    })
  }
  function hasDetailContent(v: any) {
    if (!v) return false
    const fields = [
      v.unitPrice,
      v.quoteProductCode,
      v.quoteProductBrand,
      v.quoteProductName,
      v.quoteProductSpec,
      v.quoteUnitCode,
      v.quoteUnit,
      v.deliveryPeriod,
      v.marketPrice,
      v.configDetail,
      v.paramDifference,
      v.remark,
    ]
    const hasAttachment =
      Array.isArray(v.attachmentList) && v.attachmentList.length > 0
    return (
      fields.some((x) => x !== undefined && x !== null && x !== '') ||
      hasAttachment
    )
  }
  function buildValidateNames(list: any[], requiredFields: string[]) {
    const names: any[] = []
    list.forEach((v: any, idx: number) => {
      if (hasDetailContent(v)) {
        requiredFields.forEach((field) => {
          names.push(['quotationOrderItemParamList', idx, field])
        })
      }
    })
    return names
  }
  const currentTableMemo = useMemo(() => {
    const allList = quotationItemsPage || []
    const isUnquoted = (r: any) =>
      supplierInquiryItemStatusEnum.isValueInLabels(r?.itemStatus, ['待报价'])
    const isTerminal = (r: any) =>
      supplierInquiryItemStatusEnum.isValueInLabels(r?.itemStatus, [
        '已放弃',
        '无需报价',
      ])
    const quotedList = allList.filter((r) => !isUnquoted(r) && !isTerminal(r))
    const unquotedList = allList.filter((r) => isUnquoted(r))

    const radioItemDict = {
      all: { value: `全部(${allList.length})` },
      quoted: { value: `已报价(${quotedList.length})` },
      unquoted: { value: `待报价(${unquotedList.length})` },
    }

    const key = state.currentTabKey || 'all'
    const dataSource =
      key === 'quoted'
        ? quotedList
        : key === 'unquoted'
          ? unquotedList
          : allList
    // 过滤掉已放弃和无需报价的数据，供弹框(XJForm)和提交使用
    const editDataSource = dataSource.filter((r) => !isTerminal(r))

    return {
      dataSource,
      editDataSource,
      expandedRowKeys: dataSource.map(getInquiryListRowKey),
      radioItemDict,
      defaultKey: key,
    }
  }, [quotationItemsPage, state.currentTabKey])
  async function refreshPage(options?: { skipDetailInfo?: boolean }) {
    const promises = [getItemCount(), getPagedItems()]
    if (!options?.skipDetailInfo) {
      promises.push(getDetailInfo())
    }
    await Promise.all(promises)
  }

  const toggleHideClientInfo = () => {
    dispatch(setHideClientInfoAction(!hideClientInfo))
  }

  async function getItemCount() {
    if (!id) return
    const res = await GET_QUOTATION_ITEM_COUNT(id)
    if (isResponseSuccess(res)) {
      dispatch(setQuotationItemCountAction(res.data))
      if (!initTabKeyRef.current) {
        const unquoted = res.data?.unquotedItemCount ?? 0
        dispatch(setCurrentTabKeyAction(unquoted > 0 ? 'unquoted' : 'all'))
        initTabKeyRef.current = true
      }
    } else {
      message.error(res.msg)
    }
  }

  async function getPagedItems() {
    if (!id) return
    const pageNo = state.quotationPageOption?.pageNo ?? 1
    const pageSize = state.quotationPageOption?.pageSize ?? 100000
    const res = await PAGE_QUERY_QUOTATION_ITEMS(id, { pageNo, pageSize })
    if (isResponseSuccess(res)) {
      dispatch(setQuotationItemsPageAction(res.data.content))
      dispatch(
        setQuotationPageOptionAction({
          pageNo: res.data.pageNo,
          pageSize: res.data.pageSize,
          totalCount: res.data.totalCount,
        }),
      )
      // const quotationOrderItemParamList = buildOrderParamsFromDetail(
      //   state.detailInfo?.items || [],
      // )
      // form.setFieldsValue({ quotationOrderItemParamList })
    } else {
      message.error(res.msg)
    }
  }

  function setCurrentTabKey(key: 'all' | 'quoted' | 'unquoted') {
    dispatch(setCurrentTabKeyAction(key))
  }

  function setQuotationPageOption(pageNo: number, pageSize?: number) {
    dispatch(
      setQuotationPageOptionAction({
        pageNo,
        pageSize: pageSize ?? state.quotationPageOption?.pageSize ?? 20,
        totalCount: state.quotationPageOption?.totalCount ?? 0,
      }),
    )
    getPagedItems()
  }

  function openEditModalForRecord(record: any) {
    const detailItems = currentTableMemo.dataSource || []
    const targetKey = getInquiryListRowKey(record)
    const idx = detailItems.findIndex(
      (it: any) => getInquiryListRowKey(it) === targetKey,
    )
    if (idx === -1) {
      message.warning('未找到对应明细，无法编辑')
      return
    }
    const quotationOrderItemParamList = buildOrderParamsFromDetail(detailItems)
    editForm.setFieldsValue({ quotationOrderItemParamList })
    dispatch(setEditTabIndexAction(idx))
    dispatch(setEditModalOpenAction(true))
  }

  function closeEditModal() {
    dispatch(setEditModalOpenAction(false))
  }

  function handleConfirmOrder() {
    CustomerConfirm({
      title: '确认接单？',
      content:
        '如果您核对好了询价单的信息，确认后续会给咸亨报价，请提前确认接单以便锁单',
      onOk: async () => {
        try {
          if (!id) {
            message.warning('询价ID不能为空')
            return
          }
          const hideLoading = message.loading('锁单中')
          dispatch(setIsLoadingAction(true))
          const res = await CONFIRM_ACCEPT({ inquiryId: id })

          if (isResponseSuccess(res)) {
            hideLoading()
            message.success('已成功锁单！请尽快报价')
            // 刷新页面数据
            await refreshPage()
          } else {
            console.error(res.msg || '接单失败，请重试')
          }
        } catch (error: any) {
          console.error('确认接单失败:', error)
        } finally {
          dispatch(setIsLoadingAction(false))
        }
      },
    })
  }

  function handleSubmitQuotation() {
    CustomerConfirm({
      title: '确认提交报价？',
      content: '是否确认提交？提交后信息不能主动修改，请仔细核对后再提交',
      onOk: async () => {
        try {
          // 验证表单
          const formValues = await form.validateFields()

          // 构建提交报价的参数
          const submitParams: SubmitQuotationDTO = {
            inquiryId: id,
            supplierId: detailInfo?.supplierId || '',
            contactPerson: formValues.contactPerson,
            contactPhone: formValues.contactPhone,
            contactEmail: formValues.contactEmail,
            supplierAddress: formValues.supplierAddress,
            validUntil: formValues.validUntil
              ? moment(formValues.validUntil).endOf('day').valueOf()
              : undefined,

            attachment: convertAttatchmentList(formValues.attachmentList),
            // 处理报价明细
            // items:
            //   formValues.quotationOrderItemParamList?.map(
            //     (item: any, index: number) => {
            //       const originalItem = detailInfo?.items?.[index]
            //       return {
            //         inquiryItemId:
            //           originalItem?.inquiryItemId || originalItem?.id || '',
            //         quoteProductName: item.quoteProductName,
            //         quoteProductCode: item.quoteProductCode,
            //         quoteProductSpec: item.quoteProductSpec,
            //         quoteProductBrand: item.quoteProductBrand,
            //         quoteQty: originalItem?.clientMaterialQty || 1,
            //         quoteUnit: item.quoteUnit,
            //         quoteUnitCode: item.quoteUnitCode,
            //         unitPrice: item.unitPrice,
            //         amount:
            //           (item.unitPrice || 0) *
            //           (originalItem?.clientMaterialQty || 1),
            //         deliveryPeriod: item.deliveryPeriod,
            //         includeFreight: item.includeFreight,
            //         configDetail: item.configDetail,
            //         remark: item.remark,
            //         attachment: convertAttatchmentList(
            //           item.attachmentList || [],
            //         ),
            //       }
            //     },
            //   ) || [],

            quotationId: detailInfo?.quotationId, // 编辑时使用
          }

          dispatch(setIsLoadingAction(true))
          const res = await SUBMIT_QUOTATION(submitParams)

          if (isResponseSuccess(res)) {
            message.success('报价提交成功！')
            // 刷新页面数据
            await refreshPage()
          } else {
            console.error(res.msg || '提交失败，请重试')
          }
        } catch (error: any) {
          console.error('提交报价失败:', error)
          const errorField = (error as any)?.errorFields?.[0]
          if (errorField) {
            if (errorField?.name?.includes('quotationOrderItemParamList')) {
              const tabIndex = errorField?.name?.[1]

              // 获取物资名称用于提示
              const materialName =
                detailInfo?.items?.[tabIndex]?.clientMaterialName ||
                `明细${tabIndex + 1}`
              // 显示轻提示
              message.warning(`「${materialName}」必填项未全部填写`)
              // 切换到对应的页签
              bjdFormRef.current!.getXJFormRef()?.current?.switchToTab(tabIndex)
            } else {
              // 其他表单验证错误
              message.warning(errorField?.errors?.[0] || '表单验证失败')
              // form.scrollToField(errorField?.name)
            }
          } else {
            // 未知错误
            message.warning('提交失败，请检查表单信息')
          }
        } finally {
          dispatch(setIsLoadingAction(false))
        }
      },
    })
  }

  async function handleTempSave() {
    try {
      const values = form.getFieldsValue()
      const list = values?.quotationOrderItemParamList || []
      const dataSource = currentTableMemo.dataSource || []
      const submitParams = {
        inquiryId: id,
        supplierId: state.detailInfo?.supplierId || '',
        quotationId: state.detailInfo?.quotationId,
        contactPerson: values.contactPerson,
        contactPhone: values.contactPhone,
        contactEmail: values.contactEmail,
        supplierAddress: values.supplierAddress,
        validUntil: values.validUntil
          ? moment(values.validUntil).endOf('day').valueOf()
          : undefined,
        attachment: convertAttatchmentList(values.attachmentList || []),
      }

      const hideMsg = message.loading('暂存中')
      dispatch(setIsLoadingAction(true))
      const res = await TEMP_SAVE_QUOTATION(submitParams)
      hideMsg()
      if (isResponseSuccess(res)) {
        message.success('操作成功')
        await refreshPage()
      } else {
        console.error(res?.msg)
      }
    } catch (e: any) {
      // message.error(e?.message || '暂存失败，请重试')
      console.error(e)
    } finally {
      dispatch(setIsLoadingAction(false))
    }
  }

  async function submitDetailList() {
    try {
      const values = editForm.getFieldsValue()
      const list = values?.quotationOrderItemParamList || []
      const dataSource = currentTableMemo.editDataSource || []

      const requiredFields = [
        'unitPrice',
        'quoteProductBrand',
        'quoteProductName',
        'quoteUnitCode',
        'quoteUnit',
        'deliveryPeriod',
        'includeFreight',
      ]
      const toValidateNames = buildValidateNames(list, requiredFields)

      try {
        if (toValidateNames.length > 0) {
          await editForm.validateFields(toValidateNames)
        }
      } catch (error: any) {
        const errorFields = (error?.errorFields || []) as any[]
        const invalidIdxSet = new Set<number>()
        errorFields.forEach((ef) => {
          const n = ef?.name?.[1]
          if (typeof n === 'number') invalidIdxSet.add(n)
        })
        const n = invalidIdxSet.size
        if (n > 0) {
          message.warning(`有${n}条明细的报价信息没有填写完整，请确认！`)
          const firstIdx = Math.min(...Array.from(invalidIdxSet))
          bjdFormRef.current?.getXJFormRef()?.current?.switchToTab(firstIdx)
          const firstErrorName = errorFields.find(
            (ef) => ef?.name?.[1] === firstIdx,
          )?.name
          if (firstErrorName) {
            editForm.scrollToField(firstErrorName)
          }
          return
        }
      }

      const items = list
        .map((v: any, idx: number) => {
          if (!hasDetailContent(v)) return undefined
          const origin = dataSource[idx]
          const qty = origin?.clientMaterialQty || 1
          return {
            inquiryItemId: origin?.inquiryItemId || origin?.id || '',
            unitPrice: v.unitPrice,
            marketPrice: v.marketPrice,
            quoteProductCode: v.quoteProductCode,
            quoteProductBrand: v.quoteProductBrand,
            quoteProductName: v.quoteProductName,
            quoteProductSpec: v.quoteProductSpec,
            quoteQty: qty,
            quoteUnit: v.quoteUnit,
            quoteUnitCode: v.quoteUnitCode,
            deliveryPeriod: v.deliveryPeriod,
            includeFreight: v.includeFreight,
            configDetail: v.configDetail,
            paramDifference: v.paramDifference,
            remark: v.remark,
            attachment: convertAttatchmentList(v.attachmentList || []),
            amount: (v.unitPrice || 0) * qty,
          }
        })
        .filter(Boolean)

      const submitParams: SubmitBatchQuotationItemsDTO = {
        inquiryId: id,
        supplierId: state.detailInfo?.supplierId || '',
        items: items as any,
      }

      const hideMsg = message.loading('保存中')
      dispatch(setIsLoadingAction(true))
      const res = await SUBMIT_BATCH_QUOTATION_ITEMS(submitParams)
      hideMsg()
      if (isResponseSuccess(res)) {
        message.success('操作成功')
        dispatch(setEditModalOpenAction(false))
        const autoResult = (res.data as any)?.autoSubmitResult
        if (autoResult?.autoSubmitted) {
          // 自动提交成功，整单状态已变化
          message.success(autoResult.message || '整单已自动提交')
          await refreshPage()
        } else if (autoResult?.errorMessage) {
          // 明细报价成功，但自动提交整单失败
          message.warning(autoResult.errorMessage)
          await refreshPage({ skipDetailInfo: true })
        } else {
          // 仍有未完成明细，正常刷新
          await refreshPage({ skipDetailInfo: true })
        }
      } else {
        console.error(res?.msg)
      }
    } catch (e: any) {
      console.error(e?.message || '暂存失败，请重试')
    } finally {
      dispatch(setIsLoadingAction(false))
    }
  }

  const onImportOpenChange = (open: boolean) =>
    dispatch(setImportModalOpenAction(open))

  const onImportFileChange = (list: fileFile[]) => {
    dispatch(setImportUploadListAction(list))
  }

  const getImportOriginFile = (file: RcFile) =>
    dispatch(setImportOriginFileAction(file))

  const onConfirmImport = async () => {
    if (state.importUploadList.length < 1) {
      message.warning('请上传导入文件')
      return
    }
    dispatch(setImportConfirmLoadingAction(true))
    const hideMsg = message.loading('导入中')
    try {
      const res = await IMPORT_INQUIRY_DETAIL_PAGE(state.importOriginFile!, {
        inquiryId: id,
      })
      if (isResponseSuccess(res)) {
        dispatch(setImportModalOpenAction(false))
        dispatch(setImportUploadListAction([]))
        dispatch(setImportOriginFileAction(undefined))
      }
    } catch (e: any) {
      console.error(e?.message || '导入失败')
    } finally {
      // 固定关闭弹窗
      dispatch(setImportModalOpenAction(false))
      // 无论成功失败都刷新
      await refreshPage()
      hideMsg()
      dispatch(setImportConfirmLoadingAction(false))
    }
  }

  const handleExport = async () => {
    if (!id) {
      message.warning('询价ID不能为空')
      return
    }
    const hideMsg = message.loading('导出中')
    try {
      await EXPORT_INQUIRY_DETAIL_PAGE({ inquiryId: id })
    } finally {
      hideMsg()
    }
  }

  // 放弃
  function handleGiveUpQuotation(record: any) {
    CustomerConfirm({
      title: '确认放弃报价？',
      content: '放弃后该明细将不可继续报价，是否确认放弃？',
      onOk: async () => {
        try {
          const hideLoading = message.loading('操作中')
          const res = await GIVE_UP_QUOTATION_ITEM({
            inquiryId: id,
            inquiryItemId: record.inquiryItemId || record.id || '',
            supplierId: state.detailInfo?.supplierId,
          })
          hideLoading()
          if (isResponseSuccess(res)) {
            message.success('放弃报价成功')
            const autoResult = res.data
            if (autoResult?.autoSubmitted) {
              // 自动提交成功，整单状态已变化
              message.success(autoResult.message || '整单已自动提交')
              await refreshPage()
            } else if (autoResult?.errorMessage) {
              // 明细已放弃，但自动提交整单失败
              message.warning(autoResult.errorMessage)
              await refreshPage({ skipDetailInfo: true })
            } else {
              // 仍有未完成明细，正常刷新
              await refreshPage({ skipDetailInfo: true })
            }
          } else {
            message.error(res.msg || '放弃报价失败')
          }
        } catch (error: any) {
          message.error('放弃报价失败，请重试')
          console.error('放弃报价失败:', error)
        }
      },
    })
  }

  return {
    state,
    form,
    editForm,
    refreshPage,
    toggleHideClientInfo,
    bjdFormRef,
    handleConfirmOrder,
    handleSubmitQuotation,
    handleTempSave,
    submitDetailList,
    handleExport,
    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
    currentTableMemo,
    setCurrentTabKey,
    setQuotationPageOption,
    openEditModalForRecord,
    closeEditModal,
    handleGiveUpQuotation,
  }
}
